<template>
    <div component="AppHeaderButtons" class="switcher" :class="{ hidden: false }">
        <div class="admin" v-show="shouldViewAdminButton">
            <actor-impersonator />
            <btn class="profile" icon="manage_accounts" size="icon" color="transparent" @click="gotoProfile" />
            <btn class="actors" icon="record_voice_over" size="icon" color="transparent" @click="gotoActors" />
            <btn class="contract" icon="assignment" size="icon" color="transparent" @click="gotoContract" />
            <btn class="projects" icon="grid_view" size="icon" color="transparent" @click="gotoAdmin" />
        </div>
        <btn
            class="login"
            :icon="'power_settings_new'"
            :text="'Login'"
            @click="openAuthPopup"
            v-show="!getIsLoggedIn"
        />
        <div class="hamburger" :class="{ hidden: showCloseButton }">
            <transition name="fade">
                <div class="button" size="icon" color="transparent" v-if="!getIsAnyPopupVisible" @click="openMenuPopup">
                    <i class="icon">reorder</i>
                </div>
            </transition>
            <transition name="fade">
                <div class="button" size="icon" color="transparent" v-if="getIsAnyPopupVisible" @click="closeAllPopups">
                    <i class="icon">close</i>
                </div>
            </transition>
        </div>
        <nav-button
            v-if="showCloseButton"
            class="button close"
            :class="{ visible: showCloseButton }"
            size="icon"
            color="transparent"
            :icon="'close'"
            :link="closeButtonBackLink"
        />
    </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import ActorImpersonator from '../.global/ActorImpersonator.vue';

export default {
    name: 'AppHeaderButtons',

    components: {
        ActorImpersonator,
    },

    props: {
        backLink: {
            type: String,
            required: false,
            default: '/profile',
        },
    },

    methods: {
        ...mapActions([
            'closeAllPopups',
            'openMenuPopup',
            'getIsProfileDetailOpen',
            'openAuthPopup',
            'stopActorImpersonation',
        ]),

        async gotoAdmin() {
            if (this.getUser?.isImpersonated()) {
                await this.stopActorImpersonation();
                return (document.location = '/client');
            }
            this.$router.push({ path: '/client' }).catch(() => {});
        },

        gotoProfile() {
            this.$router.push({ path: '/profile/my-voice' }).catch(() => {});
        },

        gotoActors() {
            this.$router.push({ path: '/actors' }).catch(() => {});
        },

        gotoContract() {
            this.$router.push({ path: '/contract' }).catch(() => {});
        },
    },

    computed: {
        ...mapGetters(['getIsAnyPopupVisible', 'getIsLoggedIn', 'hasRole', 'getUser', 'getIsSetActorAccessToken']),

        closeButtonBackLink() {
            return this.$route.meta.closeButtonBackLink || '';
        },

        showCloseButton() {
            return this.$route.meta.closeButtonBackLink && !this.getIsSetActorAccessToken;
        },

        shouldViewAdminButton() {
            return (
                this.getIsLoggedIn && (this.hasRole('role_administrator') || this.getUser?.isImpersonated() || false)
            );
        },
    },
};
</script>

<style lang="less" scoped>
@import '~@variables';

[component='AppHeaderButtons'] {
    .flex-row;
    z-index: 9999;
    color: white;
    cursor: pointer;
    color: black;
    pointer-events: all;

    .admin {
        .flex-row;
    }

    .hamburger {
        .flex-center;
        width: 30px;
        height: 30px;
        pointer-events: all;

        &.hidden {
            @media (max-width: 768px) {
                display: none;
            }
        }
    }

    .close {
        display: none;
        pointer-events: all;

        &.visible {
            @media (max-width: 768px) {
                display: flex;
            }
        }
    }

    button {
        color: @dark;
        margin: 0;
    }
}
</style>
